<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-card v-on:keyup.enter="buildNewSearch">
			<v-card-title>
				<h2>Moje projekty</h2>
				<v-spacer></v-spacer>
			</v-card-title>

			<v-layout align-center justify-center row>
				<v-flex xs4>
					<v-text-field
						browser-autocomplete="off"
						class="ma-2"
						v-model="searchedFields.projectName"
						label="Nazwa projektu"
						aria-label="project name"
						for="all-projects-list-project-name"
						id="all-projects-list-project-name"
					></v-text-field>
				</v-flex>
				<v-flex xs4>
					<v-autocomplete
						clearable
						class="ma-2"
						label="Nazwa naboru"
						v-model="searchedFields.contestName"
						aria-label="contest name"
						for="all-projects-list-content-name"
						id="all-projects-list-content-name"
						:items="contestNameList"
					></v-autocomplete>
				</v-flex>
				<v-flex xs2>
					<v-text-field
						browser-autocomplete="off"
						class="ma-2"
						v-model="searchedFields.projectCode"
						label="Nr projektu"
						aria-label="project code"
						for="all-projects-list-project-code"
						id="all-projects-list-project-code"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout align-center justify-center row>
				<v-flex xs2>
					<v-autocomplete
						class="ma-2"
						v-model="searchedFields.mainCountryId"
						:items="countryList"
						item-text="name"
						item-value="id"
						aria-label="project country"
						label="Kraj projektu"
						for="all-projects-list-project-country"
						id="all-projects-list-project-country"
						clearable
					></v-autocomplete>
				</v-flex>
				<v-flex xs2>
					<v-text-field
						disabled
						browser-autocomplete="off"
						class="ma-2"
						label="Nazwisko opiekuna"
						aria-label="agency project supervisor"
						for="all-projects-list-agency-project-supervisor"
						id="all-projects-list-agency-project-supervisor"
					></v-text-field>
				</v-flex>
				<v-flex xs6>
					<v-layout align-center justify-center>
						<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
						<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
						<v-btn @click="exportData" color="primary" dark class="ma-2">Eksportuj</v-btn>
						<v-menu offset-y :disabled="!exportActive">
							<template v-slot:activator="{ on }">
								<v-tooltip bottom :disabled="exportActive">
									<template v-slot:activator="{ on: onTooltip }">
										<div v-on="{...on, ...onTooltip}">
											<v-btn color="primary" dark :disabled="!exportActive">
												Eksport formularzy
											</v-btn>
										</div>
									</template>
									<span>{{ exportTooltip }}</span>
								</v-tooltip>
							</template>
							<v-list>
								<v-list
									v-for="(item, index) in exportMenu"
									:key="index">
									<v-list-tile @click="openModal(item.type)">{{ item.label }}</v-list-tile>
								</v-list>
							</v-list>
						</v-menu>
					</v-layout>
				</v-flex>
			</v-layout>

			<v-data-table
				:headers="headers"
				:rows-per-page-items="[10,20,25]"
				:items="projects"
				:pagination.sync="pagination"
				:total-items="itemCount"
				class="elevation-1"
				no-data-text="Brak projektów">
				<template v-slot:items="props">
					<td>{{ props.item.projectCode }}</td>
					<td>{{ props.item.projectName }}</td>
					<td>{{ formatMoneyWithCode(props.item.ministerDonation, props.item.currencyCode) }}</td>
					<td>{{ props.item.agencyName }}</td>
					<td>{{ props.item.mainCountry }}</td>
					<td>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon
									@click="goToProjectPanel(props.item)">
									<v-icon v-on="on">
										business
									</v-icon>
								</v-btn>
							</template>
							<span>Panel projektu</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn icon
									@click="showProject(props.item)">
									<v-icon v-on="on">
										description
									</v-icon>
								</v-btn>
							</template>
							<span>Podgląd</span>
						</v-tooltip>
					</td>
				</template>
			</v-data-table>
		</v-card>
		<agency-project-export-modal ref="agencyProjectExportModal"/>
		<agency-final-report-export-modal ref="agencyFinalReportExportModal"/>
		<agency-monitoring-export-modal ref="agencyMonitoringExportModal"/>
	</div>
</template>

<script>
	import {Pagination} from "@/utils/PaginationUtils";
	import {Api} from "@/api";
	import {AccreditationCountry} from "@/api/generated/AccreditationCountry";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {AgencyProject} from "@/api/generated/AgencyProject";
	import AgencyProjectExportModal from "./AgencyProjectExportModal";
	import AgencyFinalReportExportModal from "./AgencyFinalReportExportModal";
	import AgencyMonitoringExportModal from "./AgencyMonitoringExportModal";
  import {Numbers} from "@/utils/Numbers";
  import {Filters} from "@/utils/Filters";

  export default {
		name: "AgencyProjectTable",
		components: {AgencyMonitoringExportModal, AgencyFinalReportExportModal, AgencyProjectExportModal},
		data() {
			return {
				countryList: [],
				contestNameList: [],
				search: "",
				projects: [],
				exportActive: false,
				searchedFields: Pagination.initSearchedFields([
					'projectCode',
					'projectName',
					'contestName',
					'mainCountryId'
				]),
				headers: [
					{text: "Nr projektu", value: "projectCode", align: "left", sortable: true},
					{text: "Nazwa projektu", value: "projectName", sortable: true},
					{text: "Kwota dofinansowania", value: "ministerDonation", sortable: false},
					{text: "Nazwa placówki", value: "agencyName", sortable: true},
					{text: "Kraj projektu", value: "country", sortable: true},
					{text: "Akcje", value: "action", sortable: false},
				],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
					sortBy: null
				},
				exportMenu: [
					{label: "Eksport projektów", type: "PROJECT_EXPORT"},
					{label: "Eksport raportów z monitoringu", type: "MONITORING_REPORT_EXPORT"},
					{label: "Eksport sprawozdań końcowych", type: "FINAL_REPORT_EXPORT"},
				],
			};
		},

		mounted() {
			this.getItemList();
			this.getCountryList();
			this.getAllAgencyContestNames();
		},

		props: {
			onlyMine: {
				default: false
			},
			administratorPanel: {
				default: false
			}
		},

		watch: {
			"pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			},

			searchedFields: {
				handler() {
					this.exportActive = false;
				},
				deep: true
			},
		},

		computed: {
			searchedContestId () {
				let found = this.projects.find(project => project.contestName === this.searchedFields.contestName);
				return found ? found.contestId : null;
			},

			projectCodes () {
				return this.projects.filter(project => project.contestName === this.searchedFields.contestName)
					.map(project => project.projectCode);
			},

			exportTooltip() {
				return this.searchedFields.contestName
					? "Kliknij Szukaj"
					: "Wybierz nabór i kliknij Szukaj";
			}
		},

    mixins: [Numbers, Filters],

    created() {
      this.searchedFields = this.retrieveFilters(this.searchedFields);
      this.pagination = this.retrievePagination(this.pagination);
    },

		methods: {
			buildNewSearch() {
				this.search = this.buildSearchCriteria();
				this.exportActive = !!this.searchedFields.contestName;
				this.getItemList();
			},

			buildSort() {
				let order = this.pagination.descending === true ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			exportData() {
				let search = this.search;
				let sort = this.buildSort();
				let endpointMainPath = "agency-project";
				let path = "/" + endpointMainPath + "/export?search=" + search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList() {
				this.search = this.buildSearchCriteria();
				let sort = this.buildSort();
				Api.get(this,
					"/agency-project/list?search=" + this.search
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.projects = response.itemList;
							this.itemCount = response.itemCount;
						});
			},

			buildSearchCriteria() {
				return Pagination.buildSearchCriteria(this.searchedFields, false);
			},

			resetSearch() {
				Pagination.resetSearch(this.searchedFields);
				this.exportActive = false;
				this.getItemList();
			},

			getCountryList() {
				AccreditationCountry.get(this, successResponse => {
						this.countryList = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować kraje", errorResponse);
					});
			},

			getAllAgencyContestNames () {
				AgencyProject.getAllContestNames(this, true, successResponse => {
						this.contestNameList = successResponse.sort();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować nazw konkursów", errorResponse);
					});
			},

			goToProjectPanel (item) {
				this.$router.push("/app/agency-contest/".concat(item.contestId).concat("/project-panel/").concat(item.id));
			},

			showProject (item) {
				this.$router.openInNewTab("/view/agency-contest/" + item.contestId + "/project/" + item.agencyId + "/" + item.id);
			},

			openProjectExportModal () {
				this.$refs.agencyProjectExportModal.openModal({ ...this.searchedFields }, this.searchedContestId, null, 'USER_SUPERVISED');
			},

			openFinalReportExportModal () {
				this.$refs.agencyFinalReportExportModal.openModal({ ...this.searchedFields }, this.searchedContestId, null, 'USER_SUPERVISED');
			},

			openMonitoringExportModal () {
				this.$refs.agencyMonitoringExportModal.openModal({ ...this.searchedFields }, this.searchedContestId, null, 'USER_SUPERVISED');
			},

			openModal (type) {
				switch (type) {
					case "PROJECT_EXPORT":
						this.openProjectExportModal();
						break;
					case "FINAL_REPORT_EXPORT":
						this.openFinalReportExportModal();
						break;
					case "MONITORING_REPORT_EXPORT":
						this.openMonitoringExportModal();
						break;
				}
			},
		}
	};
</script>

<style scoped>

</style>
